import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Constant, DB } from './constants';
import LanguageDetector from 'i18next-browser-languagedetector';

const getTranslationConfigByCurrentLanguage = async () => {
  const currentLanguage = localStorage.getItem(Constant.localStorageKey.currentLanguage);
  const translationConfigDataQuery = await DB.translationConfigData.toArray();
  const currentLanguageConfig = translationConfigDataQuery.filter((config) => config.language === currentLanguage);
  if (currentLanguageConfig.length > 0){
      const translationConfig = currentLanguageConfig[0].config.datahydrotest;
      return translationConfig;
  }

  return [];
};

let currentLanguage = localStorage.getItem(Constant.localStorageKey.currentLanguage);
if (!currentLanguage) {
  currentLanguage = 'fr-FR';
  localStorage.setItem(Constant.localStorageKey.currentLanguage, currentLanguage);
}

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init(
    {
      fallbackLng: 'fr',
      resources: {
        en: {
            translation: {
                enterReportTitle: 'ENTER A REPORT',
                pendingReports: 'PENDING REPORTS',
                synchronizedReports: 'SYNCHRONIZED REPORTS',
                cancel: 'Cancel',
                confirm: 'Confirm',
                password: 'Password *',
                user: 'User',
                username: 'Username *',
                connect: 'Login',
                fieldRequire: 'This field is require *',
                invalidPassword: 'Invalid password',
                invalidUsernameOrPassword: 'Invalid username or password',
                alert: 'Alert',
                noConnection: 'No internet connection',
                reportAddedToWaitingForSynchronize: 'The report has been added to the list of reports awaiting synchronization.',
                languageNotAvailable: 'Something went wrong, this language is not available at the moment.',
                questionNotCompleted: 'A question in the form is not completed.',
                changeMaterial: 'Change Material'
            }
        },
        fr: {
            translation: {
                enterReportTitle: 'SAISIR UN RAPPORT',
                pendingReports: 'RAPPORTS EN ATTENTE',
                synchronizedReports: 'RAPPORTS SYNCHRONISES',
                cancel: 'Annuler',
                confirm: 'Confirmer',
                password: 'Mot de passe *',
                user: 'Utilisateur',
                username: 'Identifiant *',
                connect: 'connexion',
                fieldRequire: 'Ce champ est requis *',
                invalidPassword: 'Mot de passe invalide',
                invalidUsernameOrPassword: "Nom d'utilisateur ou mot de passe invalide!",
                alert: 'Alerte',
                noConnection: 'Pas de connexion internet!',
                reportAddedToWaitingForSynchronize: 'Le rapport a été ajouté à la liste des rapports en attente de synchronisation.',
                languageNotAvailable: "Une erreur s'est produite, cette langue n'est pas disponible pour le moment.",
                questionNotCompleted: "Une question du formulaire n'est pas complétée.",
                changeMaterial: 'Changer de Matériel'
            }
        }
      },
    },
    async (err, t) => {
      if (err) {
        console.error(err);
        return;
      }

      const translationConfig = await getTranslationConfigByCurrentLanguage();
      
      // Add the translation data for the current language
      i18next.addResourceBundle(currentLanguage, 'translation', translationConfig, true, true);

      // Update the language when it changes
      i18next.on('languageChanged', async (lng) => {
        const translationConfig = await getTranslationConfigByCurrentLanguage();

        // Add the translation data for the new language
        i18next.addResourceBundle(lng, 'translation', translationConfig, true, true);
      });
    },
  );

export default i18next;
